import React, { useEffect, useState } from 'react'
import './cabmob.css';
import { 
  Radio,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Box,
  Container,
  Typography,
  Button,
  Menu,
  MenuItem
} from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useUserAuth } from '../login/userAuthContext';
import { useNavigate } from 'react-router';
import CityCabMenu from '../dropdowns/dropCabCity';


const months = ["Jan'", "Feb'", "Mar'", "April", "May", "June", "July", "Aug'", "Sept'", "Oct'", "Nov'", "Dec'"];
const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]


const saerchBtnStyle = {
  borderRadius: '10px',
  width: '100px',
  fontSize: '14px',
  marginBottom:'20px'
}

export default function CabsMobile() {

  const [city1, setCity1] = useState("Mumbai")
  const [city2, setCity2] = useState("Pune");
  const [cityClicked1, setCityClicked1] = useState(true);
  const [cityClicked2, setCityClicked2] = useState(true);
  const [value, setValue] = useState('one');

  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const [date,setDate] = useState();
  const [userDate, setUserDate] = useState(new Date());
  const {user} = useUserAuth();
  const navigate = useNavigate();
  useEffect(()=>{
    setUserDate(new Date(date));
  }, [date])
  function CityCrad(props){
    const handleCityClick = (e)=> {
      e.persist();
      e.stopPropagation();
      if(props.initial==='To'){
        setCityClicked2(true);
      }else if(props.initial==='From'){
        setCityClicked1(true);
      }
    }
    return <div className='cab-mobile' onMouseOver={handleCityClick}>
      <Typography variant='body2' fontSize='14px' paddingBottom='20px'>{props.initial}</Typography>
      <Typography variant='h1' fontSize='30px' fontWeight='bolder'>{props.cityName}</Typography>
      <Typography variant='body2' fontSize='10px'>{props.airport}</Typography>
    </div>
  }
  function DateCard(props){
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleDates = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = ()=>{
    setAnchorEl(null);
  }
  const handleDateSetting = (e)=>{
    e.persist();
    if(props.showDate){
      setDate(e.target.value);
    }else{
      return;
    }
    
  }
  useEffect(()=>{
    setAnchorEl(null);
  }, [date])
    return <div className='cab-mobile'>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleDates}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{textTransform:'none'}}
      >
        {props.option}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem><input type='date' onChange={handleDateSetting}/></MenuItem>
      </Menu>
      {props.showDate && 
        <div>
        {date ? <>
          <Box display='flex'>
          <Typography variant='h1' fontSize='40px'>{userDate.getDate()}</Typography>
          <Typography variant='h3' fontSize='23px'>{months[userDate.getMonth()]}</Typography>
          <Typography variant='h3' fontSize='23px'>{userDate.getFullYear()}</Typography>
          </Box>
          <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[userDate.getDay()]}</Typography>
        </> : 
        <>
          <Box display='flex'>
          <Typography variant='h1' fontSize='40px'>{new Date().getDate()}</Typography>
          <Typography variant='h3' fontSize='23px'>{months[new Date().getMonth()]}</Typography>
          <Typography variant='h3' fontSize='23px'>{new Date().getFullYear()}</Typography>
          </Box>
          <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[new Date().getDay()]}</Typography>
        </>
        }
      </div>
      }
      {!props.showDate && <Typography variant='body2' fontWeight='bold' textAlign='left' sx={{padding:'10px'}}>Tap to add a return date for bigger discount</Typography>}
    </div>
  }
  const [time,setTime] = useState("10:00 AM")
  function Traveller(){
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
      setAnchorEl(null);
    }
    const handleClass = (e)=>{
      setTime(e.target.id);
    }
    return <div className='cab-mobile'>
       <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleOpen}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{textTransform:'none'}}
      >
        Pick-up Time
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem id='10:00 AM' onClick={handleClass}>10:00 AM</MenuItem>
        <MenuItem id='11:00 AM' onClick={handleClass}>11:00 AM</MenuItem>
        <MenuItem id='12:00 PM' onClick={handleClass}>12:00 PM</MenuItem>
        <MenuItem id='01:00 PM' onClick={handleClass}>01:00 PM</MenuItem>
        <MenuItem id='02:00 PM' onClick={handleClass}>02:00 PM</MenuItem>
        <MenuItem id='03:00 PM' onClick={handleClass}>03:00 PM</MenuItem>
        <MenuItem id='05:00 PM' onClick={handleClass}>05:00 PM</MenuItem>
        <MenuItem id='06:00 PM' onClick={handleClass}>06:00 PM</MenuItem>
        <MenuItem id='08:00 PM' onClick={handleClass}>08:00 PM</MenuItem>
      </Menu>
      <h4><span style={{fontSize:'30px', lineHeight:'0'}}>{time}</span></h4>
      <Typography variant='body2' fontWeight='500'>All class</Typography>

    </div>
  }
  const handleTickets = ()=>{
    if(user){
      navigate('/tickets/cab')
    }else{
      navigate('/login');
    }
  }

  return (
    <div>
      <div className='cabMobile'>
      <Container>
        <FormControl component="fieldset">
          <FormLabel component="legend"> </FormLabel>
          <RadioGroup name="tour" value={value} onChange={handleChange}>
          <Box
          display='flex'
          sx={{paddingTop: '40px', flexWrap:'wrap'}}
          >
            <FormControlLabel sx={{fontWeight:300}} value="one" control={<Radio checkedIcon={<CheckCircleRoundedIcon />}/>} label="Outstation One way" />
            <FormControlLabel sx={{fontWeight:300}} value="round" control={<Radio checkedIcon={<CheckCircleRoundedIcon />}/>} label="Outstation Round Trip" />
            <FormControlLabel sx={{fontWeight:300}} value="multi" control={<Radio checkedIcon={<CheckCircleRoundedIcon />}/>} label="Airport Transfer" />
            <FormControlLabel sx={{fontWeight:300}} value="extra" control={<Radio checkedIcon={<CheckCircleRoundedIcon />}/>} label="Hourly Rentals" />
          </Box>
          </RadioGroup>
        </FormControl>
      </Container>
      <div>
        <Box 
        display='flex'
        sx={{flexDirection:'column'}}
        >
          <Container><CityCrad initial={'From'} cityName={city1} /></Container>
          <Container>{cityClicked1 && <div className='cabCity1'><CityCabMenu setterFunc = {setCity1} removeMenu={setCityClicked1}/></div>}</Container>
          <Container><CityCrad initial={'To'} cityName={city2} /></Container>
          <Container>{cityClicked2 && <div className='cabCity2'><CityCabMenu setterFunc = {setCity2} removeMenu={setCityClicked2}/></div>}</Container>
          <Container><DateCard option={'Departure'} showDate={true}/></Container>
          <Container><DateCard option={'Return'} showDate={false} /></Container>
          <Container><Traveller /></Container>
        </Box>
      </div>
      <Container><Button variant='contained' sx={saerchBtnStyle} onClick={handleTickets}>SEARCH</Button></Container>
    </div>
    </div>
  )
}
